import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useFieldMappingInstance } from '@integration-app/react';
import { FieldMappingDirection, } from '@integration-app/sdk';
import { LogoLoader } from '../../LogoLoader';
const FieldMappingInstanceContext = createContext({
    fieldMappingInstance: null,
    loading: false,
    patch: null,
    setup: null,
    reset: null,
    refresh: null,
    isImport: false,
    isExport: false,
    isBidirectional: false,
});
export function useFieldMappingInstanceContext() {
    return useContext(FieldMappingInstanceContext);
}
export const FieldMappingInstanceContextProvider = ({ children, id, fallback, }) => {
    const { fieldMappingInstance, patch, setup, reset, refresh, loading } = useFieldMappingInstance(id);
    if (loading) {
        return fallback ? fallback() : _jsx(LogoLoader, {});
    }
    const isImport = fieldMappingInstance.direction === FieldMappingDirection.IMPORT ||
        fieldMappingInstance.direction === FieldMappingDirection.BOTH;
    const isExport = fieldMappingInstance.direction === FieldMappingDirection.EXPORT ||
        fieldMappingInstance.direction === FieldMappingDirection.BOTH;
    const isBidirectional = isImport && isExport;
    return (_jsx(FieldMappingInstanceContext.Provider, { value: {
            fieldMappingInstance,
            patch,
            setup,
            reset,
            refresh,
            loading,
            isImport,
            isExport,
            isBidirectional,
        }, children: children }));
};
//# sourceMappingURL=field-mapping-instance-context.js.map